import { HeartBank } from "../../../managers/HeartBank.ts";
import { Humanity as Profile } from "../../../managers/Humanity.ts";
import { Me } from "../../../managers/Me.ts";
import { Functions } from "../../../managers/Functions.ts";
import {
    getAuraColor,
    getKiitosAuraColor,
    getKiittiAuraColor,
    getKiitosAuraSize,
    getKiittiAuraSize,
    getHero
} from "../../global.ts";

import template from "./hb-humanity.mjs";
import { render } from "lit-html";
import { HbMain } from "../../hb-main/hb-main.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

import { HbAccount } from "./hb-account/hb-account.ts";
import { HbMithril } from "./hb-mithril/hb-mithril.ts";
import { HbGold } from "./hb-gold/hb-gold.ts";
import { HbPlatinum } from "./hb-platinum/hb-platinum.ts";
import { User } from "firebase/auth";

customElements.define("hb-account", HbAccount);
customElements.define("hb-mithril", HbMithril);
customElements.define("hb-gold", HbGold);
customElements.define("hb-platinum", HbPlatinum);

export class HbHumanity extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private functions = new Functions();
    private profile: Profile = new Profile();
    private me = new Me();
    private modal: ModalInterface;
    private main = document.querySelector("hb-main") as HbMain;

    private humanity: HTMLElement;
    private form: HTMLFormElement; // deprecated
    private message: HTMLParagraphElement;

    private avatar: HTMLImageElement;
    //private avatarUpload: HTMLButtonElement;
    private avatarPhoto: HTMLElement;
    private avatarRemove: HTMLButtonElement;
    private avatarChange: HTMLButtonElement;
    private avatarHeart: SVGElement;

    private silver: HbAccount;
    private mithril: HbMithril;
    private gold: HbGold;
    private platinum: HbPlatinum;

    private silverBtn: HTMLButtonElement;
    private mithrilBtn: HTMLButtonElement;
    private goldBtn: HTMLButtonElement;
    private platinumBtn: HTMLButtonElement;

    constructor() {
        super();
        render(template(), this);

        this.humanity = this.querySelector("#hb-humanity")!;
        this.form = this.querySelector("form")!;
        this.message = this.querySelector("#hb-humanity-message")!;

        this.avatar = this.querySelector("#hb-humanity-avatar")!;
        //this.avatarUpload = this.querySelector("#hb-humanity-avatar-upload")!;
        this.avatarPhoto = this.querySelector("#hb-humanity-avatar-photo")!;
        this.avatarRemove = this.querySelector("#hb-humanity-avatar-remove")!;
        this.avatarChange = this.querySelector("#hb-humanity-avatar-change")!;
        this.avatarHeart = this.querySelector("#hb-humanity-avatar-heart")!;

        this.silver = this.querySelector("hb-account")!;
        this.mithril = this.querySelector("hb-mithril")!;
        this.gold = this.querySelector("hb-gold")!;
        this.platinum = this.querySelector("hb-platinum")!;

        this.silverBtn = this.querySelector("#hb-humanity-silver")!;
        this.mithrilBtn = this.querySelector("#hb-humanity-mithril")!;
        this.goldBtn = this.querySelector("#hb-humanity-gold")!;
        this.platinumBtn = this.querySelector("#hb-humanity-platinum")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.form.reset();
                this.message.textContent = "";
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-humanity",
            override: true
        };

        this.modal = new Modal(this.humanity, modalOptions, instanceOptions);
    }

    private isBackgroundRemoved() {
        const url = new URL(this.avatar.src);
        return url.pathname.endsWith("b-avatar");
    }

    connectedCallback() {
        // this.avatarUpload.addEventListener(
        //     "click",
        //     this.updateAvatar.bind(this)
        // );
        // via server
        this.avatarPhoto.addEventListener("click", async (event) => {
            if (this.heartbank.user?.photoURL) {
                if (this.isBackgroundRemoved()) {
                    if (
                        confirm(
                            "Would you like to un-remove the background?\n\nNOTE: This will hide your Overall Aura"
                        )
                    ) {
                        this.main.showSpinner();
                        this.avatar.src =
                            await this.profile.unremoveBackground();
                        this.main.updatePhoto(this.avatar.src);
                        this.message.textContent = "";
                        this.main.hideSpinner();
                    }
                } else {
                    if (
                        confirm(
                            "Would you like to remove the background in order to show your Overall Aura?\n\nNOTE: Your Overall Aura is an average of your Inner and Outer Aura Rings"
                        )
                    ) {
                        this.main.showSpinner();
                        this.avatar.src = await this.functions.removeBackground(
                            this.heartbank.user.photoURL
                        );
                        //this.heartbank.user.getIdToken(true); // not reliable
                        this.main.updatePhoto(this.avatar.src);
                        this.message.textContent = "";
                        this.main.hideSpinner();
                    }
                }
            } else {
                this.updateAvatar(event, false);
            }
        });
        this.avatarChange.addEventListener("click", (event) => {
            this.updateAvatar(event, !this.heartbank.user?.photoURL);
        });
        this.avatarRemove.addEventListener(
            "click",
            this.removeAvatar.bind(this)
        );

        this.silverBtn.addEventListener("click", () => {
            this.reset();
            this.silver.show();
            this.silverBtn.classList.add("underline");
            this.avatarHeart.style.fill = "silver";
        });

        this.mithrilBtn.addEventListener("click", () => {
            this.reset();
            this.mithril.show();
            this.mithrilBtn.classList.add("underline");
            this.avatarHeart.style.fill = "red";
        });

        this.goldBtn.addEventListener("click", () => {
            this.reset();
            this.gold.show();
            this.goldBtn.classList.add("underline");
            this.avatarHeart.style.fill = "gold";
        });

        this.platinumBtn.addEventListener("click", () => {
            this.reset();
            this.platinum.show();
            this.platinumBtn.classList.add("underline");
            this.avatarHeart.style.fill = "purple";
        });

        this.addEventListener("hb-humanity", (e: Event) => {
            const customEvent = e as CustomEvent<{
                message: string;
                color: string;
            }>;
            this.message.textContent = customEvent.detail.message;
            this.message.style.color = customEvent.detail.color;
        });

        //this.init(null); // rendundant
        this.heartbank.addAuthStateListener((user) => {
            render(template(user), this);
            this.render(user); // default show based on membership level
        });
    }

    show(page: string) {
        switch (page) {
            case "silver":
                this.silver.rerender();
                this.silverBtn.click();
                break;
            case "mithril":
                this.mithril.rerender();
                this.mithrilBtn.click();
                break;
            case "gold":
                this.gold.rerender();
                this.goldBtn.click();
                break;
            case "platinum":
                this.platinum.rerender();
                this.platinumBtn.click();
                break;
        }
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }

    public async render(user: User | null) {
        // if (user?.phoneNumber) {
        //     this.avatar.style.borderColor = "red";
        //     this.avatarHeart.style.fill = "red";
        //     this.mithrilBtn.click();
        // } else {
        //     this.avatar.style.borderColor = "silver";
        //     this.avatarHeart.style.fill = "silver";
        //     this.silverBtn.click();
        // }

        if (user) {
            const profile = getHero(); // await this.me.getUserProfile(user.uid);
            this.avatar.style.borderColor = getKiitosAuraColor(
                profile.kiitosFrequency || 0
            );
            this.avatar.style.borderWidth = getKiitosAuraSize(
                profile.kiitosFrequency || 0,
                "l"
            );
            this.avatarPhoto.style.boxShadow = `0 0 0 ${getKiittiAuraSize(profile.kiittiAmplitude || 0, "l")} ${getKiittiAuraColor(profile.kiittiFrequency || 0)}`;
            // this.avatarPhoto.classList.add(
            //     getKiittiAuraColor(profile.kiittiFrequency || 0),
            //     getKiittiAuraSize(profile.kiittiAmplitude || 0, "l")
            // );
            this.avatarPhoto.style.background = getAuraColor(
                profile.kiitosFrequency || 0,
                profile.kiittiFrequency || 0
            );
            user.phoneNumber ? this.mithrilBtn.click() : this.silverBtn.click();
        } else {
            this.avatar.style.borderColor = "gray";
            this.avatarHeart.style.fill = "gray";
            this.avatarPhoto.style.background = "silver";
        }
    }

    private reset() {
        this.silver.hide();
        this.mithril.hide();
        this.gold.hide();
        this.platinum.hide();

        this.silverBtn.classList.remove("underline");
        this.mithrilBtn.classList.remove("underline");
        this.goldBtn.classList.remove("underline");
        this.platinumBtn.classList.remove("underline");
    }

    private async updateAvatar(event: Event, userCamera: boolean = false) {
        event.preventDefault();
        //this.avatarUpload.disabled = true;
        this.main.showSpinner();

        try {
            const src = await this.profile.updateAvatar((progress) => {
                this.message.textContent = "Upload is " + progress + "% done";
                this.message.style.color = "orange";
            }, userCamera);
            this.avatar.src = src;
            this.avatarRemove.classList.remove("hidden");
            //this.avatarPhoto.classList.remove("hidden");
            //this.avatarUpload.classList.add("hidden");
            this.message.textContent = "Profile picture updated successfully!";
            this.message.style.color = "green";

            this.main.showB(this.heartbank.user);
            this.main.renderSilver(this.heartbank.user); //TODO: does not render avatar; fix in next version using lit element
        } catch (error: any) {
            // user cancels file selection or error
            if (error.message !== "cancelled")
                this.message.textContent = error.message;
            this.message.style.color = "red";
        } finally {
            //this.avatarUpload.disabled = false;
            this.main.hideSpinner();
        }
    }

    private async removeAvatar(event: Event) {
        event.preventDefault();
        if (confirm("Would you like to delete your profile picture?")) {
            this.avatarRemove.disabled = true;
            this.main.showSpinner();

            try {
                const status = await this.profile.removeAvatar();
                this.avatar.src = new URL(
                    "../../../public/avatar.webp",
                    import.meta.url
                ).href;
                this.avatarRemove.classList.add("hidden");
                //this.avatarUpload.classList.remove("hidden");
                //this.avatarPhoto.classList.add("hidden");
                this.message.textContent = status;
                this.message.style.color = "green";

                this.main.showB(this.heartbank.user);
                this.main.renderSilver(this.heartbank.user);
            } catch (error: any) {
                this.message.textContent = error.message;
                this.message.style.color = "red";
            }

            this.avatarRemove.disabled = false;
            this.main.hideSpinner();
        }
    }
}
